import { Card, CardContent, Typography } from "@mui/material";
import { useStyle } from "./style";
import { CSSProperties, useEffect, useState } from "react";
import { useTheme } from "@/contexts/theme";

interface ICardProps {
  textColor?: string;
  text?: string;
  number?: string;
  icon?: JSX.Element;
  onClick?: () => void;
  onSecondClick?: any;
  isActive?: any;
  style?: CSSProperties;
  /** Smaller fixed-width card with tighter typography, used by the mobile statistics row. */
  compact?: boolean;
  /** Production-floor KPI tone, used by the modern quotes header. */
  tone?: string;
}

const CardComponent = ({
  text,
  textColor,
  number,
  icon,
  onClick,
  onSecondClick,
  isActive,
  style,
  compact,
  tone,
}: ICardProps) => {
  const { classes } = useStyle();
  const isModern = useTheme().currentTheme === "modern" && !compact;
  const [isFiltered, setIsFiltered] = useState(isActive || false);

  const mergedStyles = {
    ...classes.ticketStyle,
    ...(compact ? classes.ticketStyleCompact : {}),
    cursor: onClick ? "pointer" : "auto",
    border: isFiltered ? "none" : `2px solid ${textColor}`,
    backgroundColor: isFiltered ? textColor : "#FFFFFF",
  };

  const handleClick = () => {
    setIsFiltered((prev) => !prev);
    if (isFiltered && onSecondClick) {
      onSecondClick();
    } else if (!isFiltered && onClick) {
      onClick();
    }
  };

  useEffect(() => {
    setIsFiltered(isActive || false);
  }, [isActive]);

  if (isModern && !style) {
    const interactive = Boolean(onClick);
    return (
      <div
        role={interactive ? "button" : undefined}
        tabIndex={interactive ? 0 : undefined}
        className={`gm-pf-kpi${isFiltered ? " is-active" : ""}`}
        data-tone={tone}
        onClick={interactive ? handleClick : undefined}
        onKeyDown={
          interactive
            ? (event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  handleClick();
                }
              }
            : undefined
        }
      >
        <span className="gm-pf-kpi-icon" aria-hidden>
          {icon}
        </span>
        <span className="gm-pf-kpi-copy">
          <em>{text}</em>
          <strong>{number}</strong>
        </span>
      </div>
    );
  }

  return (
    <Card sx={style || mergedStyles} onClick={onClick && handleClick}>
      <CardContent
        style={{
          ...classes.ticketContentStyle,
          ...(compact ? classes.ticketContentStyleCompact : {}),
        }}
      >
        <Typography
          sx={{
            ...classes.textStyle,
            ...(compact ? classes.textStyleCompact : {}),
          }}
          color={isFiltered ? "#FFFFFF" : textColor}
        >
          {icon}
          {text}
        </Typography>
        <Typography
          sx={{
            ...classes.numberStyle,
            ...(compact ? classes.numberStyleCompact : {}),
          }}
          color={isFiltered ? "#FFFFFF" : textColor}
        >
          {number}
        </Typography>
      </CardContent>
    </Card>
  );
};
export { CardComponent };
